<template>
  <div class="integral">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onSearchListLoad">
        <div v-for="item in list" :key="item.id" class="hidden">
          <div class="left f-l">
            <div class="type">{{item.businessSubject}}   {{item.businessDesc}}</div>
            <div class="gray">{{item.businessTime}}</div>
          </div>
          <div class="f-r" :class="item.modifyType == 1 ? 'c_yellow' : '' ">
            <!-- modifyType  1 +   2 -  -->
         {{item.modifyType == 1 ? '+' :'-'}} {{item.modifyIntegral}}
          </div>
        </div>
      </van-list>
    </van-pull-refresh>


  </div>
</template>

<script>
import http from "@/utils/axios";
export default {
  data() {
    return {
      arrow: "arrow-down",
      list: [],
      loading: false,
      finished: false,
      refreshing:false,
      pageIndex: 0,
    };
  },
  created() {
    this.$loading.hide();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.pageIndex = 1;
        this.list = [];
        //恢复不是最后一页
        this.finished = false;
        this.loading = true;
        this.getList();
      }, 1000);
    },
    onSearchListLoad() {
      this.pageIndex++;
      this.loading = true;
      this.getList()
    },
    // 获取积分消费列表
    getList() {
      // 下拉刷新
      if (this.refreshing) {
        this.refreshing = false;
      }
      const { phone } = this.$route.query;
      const floor = this.$route.params.floor;
      let params = {
        pageIndex: this.pageIndex,
        pageSize: 10,
        phone: phone ? phone : (floor.vipIntegral && floor.vipIntegral.phone || '')
      }
      http({
        url: "order/user/integral/wrapperPageList",
        method: "post",
        parmes: params
      },true).then(res => {
        if (res.code == 200) {
          if (res.data.list.length != 0) {
            this.list.push(...res.data.list)
            this.loading = false;
          } else {
            this.finished = true;
            this.loading = false;
          }
        }
      })

      // const obj = {
      //   accountExternalUserId: "CENTER_ACCOUNT",
      //   action: "A",
      //   businessSubject: "中心账户初始化积分",
      //   businessType: 101,
      //   creator: "[SYS]",
      //   gmtCreated: "2021-10-30 14:21:45",
      //   gmtModified: "2021-11-04 13:48:24",
      //   id: 1,
      //   integralAccountId: 1,
      //   isDeleted: "n",
      //   modifier: "[SYS]",
      //   modifyIntegral: 1000,
      //   modifyType: 1
      // }
      // // 异步更新数据
      // // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // setTimeout(() => {
      //   for (let i = 0; i < 10; i++) {
      //     this.list.push({ ...obj, id: i + '' + this.pageIndex + 1 });
      //   }

      //   // 加载状态结束
      //   this.loading = false;

      //   // 数据全部加载完成
      //   if (this.list.length >= 100) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
  }
};
</script>

<style lang="less" scoped>
  .integral {
    // font-size: 32px;
    margin-top: 20px;
  }
  .hidden {
    overflow: hidden;
    border-bottom: 1px solid #ddd;
    padding: 30px 55px;
    background: #fff;
  }
  .f-l {
    float: left;
  }
  .f-r {
    float: right;
  }
  .left {
    max-width: 80%;
  }
  .type {
    font-size: 24px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .gray {
    color: #999;
    font-size: 20px;
    margin-top: 8px;
  }
  .hidden .f-r{
    font-size: 36px;
    // font-weight: 600;
    margin-top: 5px;
  }
  .c_yellow{
    color: #F8A651;
  }
</style>